import { useMemo, useState } from "react";

const usePagination = (data: any, itemsPerPage: any, topRef?: any) => {
  //STATE CONSTANT
  const [currentPage, setCurrentPage] = useState(1);
  const currentData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data?.slice(startIndex, endIndex);
  }, [currentPage, data, itemsPerPage]);

  // LIFECYCLE

  const totalPages = useMemo(
    () => Math.ceil(data?.length / itemsPerPage),
    [data?.length, itemsPerPage]
  );

  // EVENT HANDLERS
  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (topRef) {
      topRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return {
    currentPage,
    totalPages,
    currentData,
    handlePageChange,
  };
};

export default usePagination;
